import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import NotFound from '../NotFound';
import ListView from './ListView';
import EditView from './EditView';
import ShowView from './ShowView';

const InventoryPage = ({ match: { path } }) => (
  <Switch>
    <Route exact path={path} component={ListView} />
    <Route path={`${path}/create`} component={EditView} />
    <Route path={`${path}/edit/:id`} component={EditView} />
    <Route path={`${path}/show/:id`} component={ShowView} />
    <Route component={NotFound} />
  </Switch>
);

InventoryPage.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
};

export default InventoryPage;
